import React from "react";
import "../styles/Footer.css";
import { useNavigate } from "react-router-dom";

function Footer() {

  const navigate = useNavigate()

    function handleClick() {
        navigate('/')
    }

    function handleClick2() {
      navigate('/aboutus')
  }

  function handleClick3() {
    navigate('/portfolio')
  }

  function handleClick4() {
    navigate('/investment')
  }


  return (
    <>
      <section class="">
        <footer class="footcolor text-white pb-5">
          <div class="container ms-lg-0 pb-5 pt-5">
            <div class="row">
              <div class="col-lg-5 col-md-12 mb-4 mb-md-0 ps-lg-5  pe-lg-0">
          
              <div className="d-flex">

          <img
            src={require("../images/kpn investments logo (2).png")}
            className="hover"
            alt="success"
            style={{ height: "80px" }} // Adjust height as needed
            onClick={handleClick}
          />
          <h1 className="text-white navtxt mt-4 ms-3 hover" onClick={handleClick}>KPN Investments</h1>
          </div>

                <p className="footerlogosub pt-3">
                Smart Investments, Exceptional Returns.
                </p>
              </div>

              <div class="col-lg-3 col-md-6 mb-4 mb-md-0 pe-lg-4 ps-lg-0">
                <h5 class="text-uppercase mb-3 footerfont1">Contact</h5>

                <div class="foot">
                  <div className="footerfont2">Yugandhar Kummathi </div>
                  <div className="footerfont2">+1 904 436 8696 </div>
                  <div className="footerfont2">
                 info@kpnservicesllc.com
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-4 mb-md-0 ps-lg-0">
                <h5 class="text-uppercase mb-3 footerfont1">Useful links</h5>

                <div class="foot2">
                  <div onClick={handleClick} className="footerfont2 hover">Home</div>
                  <div onClick={handleClick2} className="footerfont2 hover">About us</div>
                  <div onClick={handleClick3} className="footerfont2 hover">Portfolio</div>
                  <div onClick={handleClick4} className="footerfont2 hover">Investment</div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </section>
    </>
  );
}

export default Footer;
